import * as React from "react";
import InputBox from "./InputBox";
import styled from "./styled-components";
import Scatterplot from "./Scatterplot";

const Section = styled.div`
  margin: 0 2em 0 2em;
`;

const ResultWordNeighbors = styled.div`
  display: none;
  transition: 0.5s;
  margin-right: 0.2em;
  z-index: 10;
  font-size: 13px;
  background-color: #ffffff;
  color: grey;
`;

const ResultBox = styled.div<any>`
  padding: 1em;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between; /* when graph is added, space-between/space-around */
  visibility: ${({ hasResult }) => (hasResult ? "visible" : "hidden")};
  &:hover ${ResultWordNeighbors} {
    display: inline-block;
  }
`;

const ResultWordNeighbor = styled.div`
  display: inline-block;
  div {
    display: inline-block;
  }
`;

const ScatterplotWrapper = styled.div`
  flex-basis: 300px;
`;

const ResultWordWrapper = styled.div`
  color: #40a9ff;
  font-size: 1.2em;
  display: flex;
  align-items: middle;
`;

const ResultWord = styled.div`
  font-size: 1em !important;
  background-color: #eaeaea;
  padding: 5px 5px 5px 5px;
  border-radius: 4px;
  vertical-align: middle;
  cursor: pointer;
  color: #6b6b6b;
  margin-left: 10px;
  transition: 0.5s;
  :hover {
    transition: 0.5s;
    background-color: #e0e0e0;
  }
`;

interface IProps {
  id: number;
  onResult(id: number, topResult: string): void;
}

export interface IResult {
  distance: number;
  word: string;
  x: number;
  y: number;
  primary: boolean;
}

interface IState {
  results: IResult[];
  loading: boolean;
  error: string;
  errorWords: string[];
  primaryWord: string;
}

class IOPair extends React.Component<IProps, IState> {
  public readonly state = {
    error: "",
    errorWords: [],
    loading: false,
    primaryWord: "",
    results: []
  };
  public onSubmit = (expression: string) => {
    this.setState({ loading: true, results: [] });
    const t = this;
    const payload = { expression };
    const url =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5000/compute"
        : "https://semantic-api.a9.io/compute";
    fetch(url, {
      body: JSON.stringify(payload),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "POST",
      mode: "cors"
    })
      .then(response => response.json())
      .then(blob => {
        if (blob.error) {
          t.setState({
            error: blob.text,
            errorWords: blob.words || [],
            loading: false,
            primaryWord: "",
            results: []
          });
        } else {
          t.setState({ loading: false, results: blob.results, error: "" });
          const primaryWord = blob.results.filter(
            ({ primary }: IResult) => primary
          );
          if (primaryWord.length === 0) {
            t.setState({
              error:
                "Could not find any results that weren't in the original expression!",
              loading: false,
              results: []
            });
          } else {
            t.props.onResult(t.props.id, primaryWord[0].word);
            t.setState({ primaryWord: primaryWord[0].word });
          }
        }
      })
      .catch(e => {
        t.setState({
          error: e.toString(),
          loading: false,
          primaryWord: "",
          results: []
        });
      });
  };
  public render() {
    const { error, errorWords, loading, results, primaryWord } = this.state;
    return (
      <Section>
        <InputBox
          onSubmit={this.onSubmit}
          error={error}
          errorWords={errorWords}
          loading={loading}
        />
        <ResultBox hasResult={primaryWord !== ""}>
          <ScatterplotWrapper>
            <Scatterplot data={results} width={300} height={100} />
          </ScatterplotWrapper>
          <ResultWordWrapper>
            <ResultWordNeighbors>
              {results.slice(0, 5).map((result: IResult, i: number) => (
                <ResultWordNeighbor key={i}>
                  <div style={{ color: "#40a9ff", fontWeight: "bold" }}>
                    {result.word}
                  </div>
                  : <div>{result.distance}</div>
                  &nbsp;
                </ResultWordNeighbor>
              ))}
            </ResultWordNeighbors>
            <div>&#8776;</div>
            <ResultWord>{primaryWord} </ResultWord>
          </ResultWordWrapper>
        </ResultBox>
      </Section>
    );
  }
}

export default IOPair;



// WEBPACK FOOTER //
// ./src/IOPair.tsx